var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"landing-page"},[_c('h1',[_vm._v("404 Error.")]),_c('p',[_vm._v("We can't find the page you're looking for.")]),_c('router-link',{attrs:{"to":"/"}},[_c('button',[_vm._v("Back to home")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }